module.exports = __webpack_public_path__ + "img/ai.3269306e.png";